export default function getResource(label, vars = []) {
    const resources = {
        UPCOMING: 'Upcoming',
        PAST: 'Past',
        CANCELLED: 'Cancelled',
        CANCELLED_BY_STORE: 'Canceled By Store',
        LATE_CANCELLATION: `Late Cancelation $${vars[0]} Fee`,
        NO_SHOW: `No Show $${vars[0]} Fee`,
        reschedule: 'Reschedule',
        cancel: 'Cancel',
        bookAgain: 'Book Again',
        viewProduct: 'View Product Recs',
        cancelRSVP: 'Cancel RSVP',
        rsvp: 'RSVP',
        free: 'FREE'
    };

    return resources[label];
}
